import React from "react";
import moment from "moment";
import numeral from "numeral";
import clsx from "clsx";

import { Popover, OverlayTrigger, Dropdown, MenuItem, ButtonToolbar } from "react-bootstrap";
import { toast } from "react-toastify";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMapMarker,
  faComments,
  faTrash,
  faUsers,
  faChevronDown,
  faChevronUp
} from "@fortawesome/free-solid-svg-icons";

import { isEnabled } from "utils/featureFlags";

import { Button, ButtonGroup, Icon } from "aible";
import { LineInput } from "components/Inputs/LineInput";
import Tooltip from "components/Inputs/Tooltip";
import { Tooltip as ShadcnTooltip, TooltipTrigger, TooltipContent } from "aible/Tooltip/Tooltip";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import FineTuningButton from "components/LanguageModelArtifact/FineTuningButton/FineTuningButton";

import FirstVarIcon from "images/Next-Icons/drill-in-2.svg";
import SecondVarIcon from "images/Next-Icons/drill-in-1.svg";
import StatAssocIcon from "images/Next-Icons/stats.svg";
import PopularIcon from "images/Next-Icons/mode-voting.svg";
import VotingIcon from "images/Next-Icons/model-voting.svg";
import PPTDownloadIcon from "images/Next-Icons/PPTDownloadIcon.svg";
import GreyPPTDownloadIcon from "images/Next-Icons/PPTDownloadIcon-grey.svg";
import ReviewDeployIcon from "images/Next-Icons/ReviewDeployIcon.svg";
import IndentIcon from "images/Next-Icons/IndentIcon.svg";

import EditIcon from "images/edit-light.svg";

import RadarIcon from "images/radar-light.svg";

import PinnedIcon from "images/Sense-Icons/pinned.svg";
import UnpinnedIcon from "images/Sense-Icons/unpinned.svg";
import PinnedHoverIcon from "images/Sense-Icons/unpin.svg";

import IntegrateIcon from "images/Next-Icons/IntegrateIcon.svg";
import MonitorSettingsIcon from "images/Next-Icons/MonitorSettingsIcon.svg";

import StethoscopeIcon from "images/Next-Icons/StethoscopeIcon.svg";
import LabVialIcon from "images/Next-Icons/LabVialIcon.svg";
import SecurityCheckIcon from "images/Next-Icons/SecurityCheckIcon.svg";
import WaypointIcon from "images/Next-Icons/WaypointIcon.svg";
import BullseyeIcon from "images/Next-Icons/BullseyeIcon.svg";
import MiniFunnelIcon from "images/Next-Icons/MiniFunnelIcon.svg";
import NewMoneyIcon from "images/Next-Icons/NewMoneyIcon.svg";
import MicroscopeIcon from "images/Next-Icons/MicroscopeIcon.svg";
import ReturnIcon from "images/Next-Icons/ReturnIcon.svg";
import GearsIcon from "images/Next-Icons/GearsIcon.svg";
import ChartIcon from "images/Next-Icons/ChartIcon.svg";
import SpreadsheetIcon from "images/Next-Icons/SpreadsheetIcon.svg";
import ScalesIconWhiteBackground from "images/Next-Icons/ScalesIconWhiteBackground.svg";
import TodoAssignIcon from "images/Next-Icons/TodoAssignIcon.svg";
import TodoFeedbackIcon from "images/Next-Icons/TodoFeedbackIcon.svg";
import TodoAddIcon from "images/Next-Icons/TodoAddIcon.svg";
import TodoXIcon from "images/Next-Icons/TodoXIcon.svg";
import ClassicIcon from "images/Next-Icons/gallery-thumbnails-light.svg";
import chatIcon from "images/chatbubble.svg";

import ListViewHeaderIcon from "images/Next-Icons/list-view-header.svg";
import HexViewHeaderIcon from "images/Next-Icons/hex-view-header.svg";
import NLQDashIcon from "images/presentation-screen-purple.svg";

import HexGridContainer from "containers/Next/HexGrid";
import MinimapViewContainer from "containers/Next/MinimapView";
import NextReportContainer from "containers/Next/NextReport";
import NextChartContainer from "components/Next/Charts/NextChart";
import CommentModalContainer from "containers/Next/Comments/CommentModal";
import TransformContainer from "containers/Next/Transform/Transform";
import ModelsContainer from "containers/Next/Models/Models";
import OverviewContainer from "containers/Next/Overview/Overview";
import SubgroupContainer from "containers/Next/Subgroup/Subgroup";
import DeploySettingsContainer from "containers/Next/Deploy/DeploySettings";
import TrainContainer from "containers/UnifiedProject/Train/Train";
import AdvancedCostsContainer from "containers/CreateWizard/Costs/AdvancedCosts";
import BaselineCostsCardContainer from "containers/UnifiedProject/RealityCheck/BaselineCostsCard";
import OptimizeContainer from "containers/UnifiedProject/Optimize/Optimize";

import LeakageChartContainer from "containers/Next/Charts/LeakageChart";

import ForecastContainer from "containers/UnifiedProject/Forecast/Forecast";

import SubgroupMenuContainer from "containers/Business/SubgroupMenu/SubgroupMenu";

import NextFooterContainer from "containers/Next/Footer/NextFooter";
import DashboardHolderContainer from "containers/Next/Dashboard/DashboardHolder";

import ModelBoxContainer from "containers/Business/ModelBox/ModelBox";

import SelectDataWrapperContainer from "containers/UnifiedProject/SelectData/SelectDataWrapper";
import ObjectiveContainer from "containers/UnifiedProject/Objective/Objective";
import RealityCheckContainer from "containers/UnifiedProject/RealityCheck/RealityCheck";
import StrategyContainer from "containers/Business/Strategy/Strategy";
import BusinessConstraintsContainer from "containers/Business/Strategy/BusinessConstraints";
import ModelListContainer from "containers/Business/ModelList/ModelList";
import PredictContainer from "containers/UnifiedProject/TestPredictions/TestPredictions";

import DeployContainer from "containers/UnifiedProject/Deploy/Deploy";
import IntegrateContainer from "containers/UnifiedProject/Integrate/Integrate";

import MarketContainer from "containers/Market/Market";
import CreateJobModalContainer from "containers/Market/Jobs/CreateJobModal";

import GalleryContainer from "containers/Gallery/Gallery";

import { centerHex } from "containers/Next/NextReducer";
import * as nextReducer from "containers/Next/NextReducer";
import * as wizardReducer from "containers/Wizard/reducer";

import { readableSearch } from "containers/Next/Models/ModelsReducer";

import ChatGPTContainer from "components/ChatGPT/ChatGPT";
import NextHeaderTabs from "components/Next/NextHeaderTabs";
import ChatGPTHeader from "components/Next/ChatGPTHeader";

import styles from "./style.module.css";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";

export default class Next extends React.PureComponent {
  constructor(props) {
    super(props);

    this.miniRef = React.createRef();
    const isListMode = localStorage.getItem("aible_is_list_mode");
    const isHideMinimap = localStorage.getItem("aible_hide_minimap");

    this.state = {
      canDrag: false,
      isSearchOpen: false,
      isExpand: false,
      showReplay: false,
      showGuideModal: false,
      isList: isListMode === "true",
      todoMaximize: {},
      isDeployingProject: false,
      isComment: false,
      hideMinimap: isHideMinimap === "true",
      isDefaultExplore: props?.exploreDefaultViewMode === "EXPLORE"
    };
  }

  componentDidMount() {
    const { hexagonRadius, updateSelectedHex, isGuided } = this.props;

    this.miniRef &&
      this.miniRef.current &&
      this.miniRef.current.addEventListener("mousemove", (e) => this.handleMiniClick(e, true), false);
    if (isGuided) {
      this.setState({ showGuideModal: true });
    }
  }

  componentWillUnmount() {
    this.miniRef &&
      this.miniRef.current &&
      this.miniRef.current.removeEventListener("mousemove", this.handleMiniClick.bind(this));
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.isList && this.props.comparisonOptions?.dateField) {
      this.setState({ isList: false });
    }
  }

  handleUpdateIsList(isList) {
    localStorage.setItem("aible_is_list_mode", isList);

    this.setState({ isList: isList });

    return setTimeout(() => centerHex({ x: 8, y: 8 }), 200);
  }

  handleMiniClick(event, checkDrag = false) {
    const { canDrag } = this.state;

    const mainScroll = document.getElementById("mainScroll");

    if (mainScroll && (checkDrag === false || canDrag === true)) {
      const currentTargetRect = event.currentTarget.getBoundingClientRect();
      const event_offsetX =
        event.pageX - currentTargetRect.left - (240 / 2) * (mainScroll.offsetWidth / mainScroll.scrollWidth);
      const event_offsetY =
        event.pageY -
        currentTargetRect.top -
        ((180 / 2) * (mainScroll.offsetHeight / mainScroll.scrollHeight) - 60 * (17 / 297));

      const scrollTop = (event_offsetY / 180) * mainScroll.scrollHeight;
      const scrollLeft = (event_offsetX / 240) * mainScroll.scrollWidth;

      mainScroll.scrollTo({ top: scrollTop, left: scrollLeft });
    }
  }

  renderFooter() {
    const { id, datasetId, blueprintId } = this.props;

    return <NextFooterContainer id={id} datasetId={datasetId} blueprintId={blueprintId} />;
  }

  renderLeft(showPinnedHex = false) {
    const {
      id,
      datasetId,
      projectId,
      runId,
      blueprint,
      optimized,
      selectedHexModels,
      pinnedHex,
      setupSection,
      overallRunId,
      reportLabel,
      isNextBlueprintEdit
    } = this.props;

    const retProps = {
      id: projectId,
      runId: projectId === "new" ? "new" : runId,
      datasetId: datasetId,
      nextId: id,
      isNext: true,
      isModelsNext: true,
      hideModel: true,
      reportLabel: reportLabel,
      isNextBlueprintEdit: isNextBlueprintEdit,
      nextBlueprint: blueprint
    };

    const rSetupSection =
      setupSection !== undefined
        ? setupSection
        : showPinnedHex
          ? pinnedHex?.leftSection
          : selectedHexModels?.leftSection;

    const styles =
      rSetupSection === "PREDICT_WHAT_IF"
        ? { width: "35vw" }
        : rSetupSection === "STRATEGY"
          ? { width: "100%", height: "calc(100% - 120px)", overflowY: "auto" }
          : rSetupSection === "BASELINE"
            ? {
                maxWidth: "70vw",
                maxHeight: "calc(100% - 120px)",
                marginBottom: "10px",
                overflow: "auto"
              }
            : rSetupSection === "BLUEPRINT"
              ? { height: "90%", overflowY: "scroll" }
              : rSetupSection === "ADD_JOB" || rSetupSection === "MODEL_METRICS" || rSetupSection === "MODEL_CHARTS"
                ? { height: "calc(100% - 120px)", overflowY: "auto" }
                : {};

    return (
      <div className={styles.reportGallery} style={styles} id={"reportGalleryMiddle"}>
        {rSetupSection !== undefined ? (
          rSetupSection === "HOME" || rSetupSection === "REVIEW_AI" ? (
            <ModelListContainer {...retProps} hideModelBox />
          ) : rSetupSection === "DEPLOY_SETTINGS" ? (
            <DeploySettingsContainer {...retProps} />
          ) : rSetupSection === "MODEL_METRICS" ? (
            <TrainContainer
              {...retProps}
              id={optimized && optimized.innerId !== undefined ? optimized.innerId : "new"}
              projectId={projectId}
              renderDetails
            />
          ) : rSetupSection === "MODEL_CHARTS" ? (
            <TrainContainer
              {...retProps}
              id={optimized && optimized.innerId !== undefined ? optimized.innerId : "new"}
              projectId={projectId}
            />
          ) : rSetupSection === "FAIR_GUIDE" ? (
            <ObjectiveContainer {...retProps} runId={overallRunId} />
          ) : rSetupSection === "PREDICT_WHAT_IF" ? (
            <PredictContainer id={runId} runId={runId} projectId={projectId} isNext />
          ) : rSetupSection === "MONITOR" ? (
            <DeployContainer {...retProps} isAdvancedOptions />
          ) : rSetupSection === "INTEGRATE" ? (
            <IntegrateContainer {...retProps} />
          ) : rSetupSection === "SUBGROUP" ? (
            <SubgroupContainer {...retProps} />
          ) : rSetupSection === "BLUEPRINT" ? (
            <SelectDataWrapperContainer
              {...retProps}
              hideBlueprint
              isBlueprintPicker={true}
              type={wizardReducer.STEP_TYPE.ACADEMIC_REVIEW_DATASET.id}
              reportLabel={reportLabel}
              nextId={id}
              blueprintPickerHeader
            />
          ) : rSetupSection === "BASELINE" ? (
            <RealityCheckContainer {...retProps} />
          ) : //<OptimizationContainer {...retProps} />
          rSetupSection === "STRATEGY" ? (
            <BusinessConstraintsContainer {...retProps} />
          ) : rSetupSection === "EXPECTED" ? (
            <StrategyContainer {...retProps} />
          ) : rSetupSection === "ADD_JOB" ? (
            <CreateJobModalContainer id={id} noModal />
          ) : (
            <GalleryContainer runId={runId} datasetId={datasetId} isNext isConsumer nextId={id} />
          )
        ) : (
          <GalleryContainer runId={runId} datasetId={datasetId} isNext isConsumer nextId={id} />
        )}
      </div>
    );
  }

  renderOverview() {
    return <div className={styles.leftOverview}>{}</div>;
  }

  getIsOverallSegment() {
    const { project, optimized } = this.props;

    return (
      optimized &&
      optimized.innerSegment &&
      optimized.innerSegment.conditions.length === 0 &&
      optimized.innerSegment.job &&
      optimized.innerSegment.job.job_id === optimized.innerId &&
      project &&
      project.segments &&
      project.segments.length > 1
    );
  }

  renderTodo(todo, isMaximize = false, todoNode = undefined, isPinned = false) {
    const {
      id,
      datasetId,
      projectId,
      blueprintId,
      runId,
      isEditBlueprint,
      blueprint,
      todoMaximize,
      modelTodos,
      optimized,
      hasSetupChanged,
      selectedHexModels,
      pinnedHex,
      assignTodo,
      handleStartBreadcrumbs,
      overallRunId,
      updatePinnedHex,
      handleBackModels,
      handleUpdate,
      updateIsCommentModal,
      updateIsEditBlueprint,
      nodeAssign,
      reportLabel,
      modelGroups,
      deployment,
      selectedScenario,
      hasSameScenario,
      isNextBlueprintEdit
    } = this.props;

    const retProps = {
      id: blueprintId === "new" ? "new" : blueprintId !== undefined && projectId === undefined ? runId : projectId,
      runId: blueprintId === "new" ? "new" : projectId === "new" ? "new" : runId,
      datasetId: datasetId,
      nextId: id,
      isNext: true,
      isModelsNext: true,
      hideModel: true,
      isNextBlueprintEdit: isNextBlueprintEdit,
      nextBlueprint: blueprint
    };

    const { isList } = this.state;

    let todoParents = {};

    modelTodos &&
      Object.keys(modelTodos).forEach((k) => {
        const todo = modelTodos[k];

        if (todo?.parent?.id !== undefined) {
          todoParents[todo?.parent?.id] = todo?.parent;
        }
      });

    const retIsMax = todoMaximize[todo] === true || isMaximize === true;

    const assigned = nodeAssign?.[todo];

    const buttonStyle =
      blueprintId !== undefined
        ? { padding: "3px" }
        : {
            padding: "3px",
            color: "#7E69D7"
          };
    let fontColor = "white";
    let activeColor = "#7E69D7";
    if (
      modelGroups &&
      modelGroups.drilldownValues &&
      modelGroups.drilldownValues.filter((d) => d.runId === runId && d.value !== "Overall").length > 0
    ) {
      activeColor = modelGroups.drilldownValues.filter((d) => d.runId === runId)[0].color;
      fontColor = "#4B495B";
    }

    const isCurrentDeployed = selectedScenario?.isApproved && hasSameScenario;
    const shouldSaveScenario = !hasSameScenario;

    return (
      <div className={styles.todoSection} key={"todo_" + todo?.id}>
        <div
          className={isList ? styles.todoHeader : styles.todoHeaderStatic}
          style={
            blueprintId !== undefined
              ? { background: "rgb(74, 144, 226)" }
              : selectedHexModels?.leftSection === "INTEGRATE"
                ? { backgroundColor: "rgb(126, 105, 215)" }
                : retIsMax && isList
                  ? { background: "#6454ac" }
                  : { backgroundColor: activeColor, color: fontColor }
          }
        >
          {todo && (
            <div className={styles.hexIcon}>
              <img
                src={
                  todo === "DEPLOY_REVIEW"
                    ? ReviewDeployIcon
                    : todo === "DEPLOY_INTEGRATION"
                      ? IntegrateIcon
                      : todo === "DEPLOY_MONITOR"
                        ? MonitorSettingsIcon
                        : todo === "OPTIMIZE_STRATEGY"
                          ? BullseyeIcon
                          : todo === "OPTIMIZE_TRANSACTION"
                            ? MiniFunnelIcon
                            : todo === "OPTIMIZE_COSTS"
                              ? NewMoneyIcon
                              : todo === "OPTIMIZE_BLUEPRINT"
                                ? WaypointIcon
                                : todo === "PREDICT_WHAT_IF"
                                  ? StethoscopeIcon
                                  : todo === "DEPLOY_REVIEW"
                                    ? LabVialIcon
                                    : todo === "FAIR_GUIDE"
                                      ? ScalesIconWhiteBackground
                                      : todo === "FAIR_VALUE"
                                        ? SecurityCheckIcon
                                        : todo === "BUDGET_SUBGROUP"
                                          ? MicroscopeIcon
                                          : todo === "BUDGET_RETRAIN"
                                            ? ReturnIcon
                                            : todo === "EVAL_MODEL_DRIVERS"
                                              ? GearsIcon
                                              : todo === "REVIEW_MODEL_METRICS"
                                                ? SpreadsheetIcon
                                                : todo === "REVIEW_MODEL_CHARTS"
                                                  ? ChartIcon
                                                  : null
                }
              />
            </div>
          )}
          <div className={styles.todoText}>
            {readableSearch[todo] || todo}
            {assigned && assigned.length > 0 && (
              <div className={styles.sText} style={{ marginRight: "5px" }}>
                {"Assigned: " + assigned.reduce((a, b, i) => a + b?.author + (i < assigned.length - 1 ? ", " : ""), "")}
              </div>
            )}
          </div>

          <div className={styles.todoTopButtons} style={retIsMax ? { opacity: "1", pointerEvents: "all" } : {}}>
            <ButtonGroup>
              {isPinned !== true && (
                <OverlayTrigger
                  placement="top"
                  trigger={["hover"]}
                  rootClose
                  overlay={
                    <Popover id="popover-positioned-top">
                      <div>{"Close"}</div>
                    </Popover>
                  }
                >
                  <Button style={buttonStyle} onClick={() => handleBackModels()}>
                    {/* {"Close"} */}
                    <img src={TodoXIcon} />
                  </Button>
                </OverlayTrigger>
              )}
              <OverlayTrigger
                placement="top"
                trigger={["hover"]}
                rootClose
                overlay={
                  <Popover id="popover-positioned-top">
                    <div>{"Add Todo"}</div>
                  </Popover>
                }
              >
                <Button
                  style={buttonStyle}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleStartBreadcrumbs(todoNode ? todoNode : modelTodos[todo]);
                  }}
                >
                  <img src={TodoAddIcon} />
                </Button>
              </OverlayTrigger>
              <OverlayTrigger
                placement="top"
                trigger={["hover"]}
                rootClose
                overlay={
                  <Popover id="popover-positioned-top">
                    <div>{"Feedback"}</div>
                  </Popover>
                }
              >
                <Button
                  style={buttonStyle}
                  onClick={(e) => {
                    e.stopPropagation();
                    updateIsCommentModal({
                      aTypeReadable: modelTodos[todo]?.text,
                      node: modelTodos[todo],
                      nextId: id
                    });
                  }}
                >
                  {/* {"Comment"} */}
                  <img src={TodoFeedbackIcon} />
                </Button>
              </OverlayTrigger>
              <OverlayTrigger
                placement="top"
                trigger={["hover"]}
                rootClose
                overlay={
                  <Popover id="popover-positioned-top">
                    <div>{"Assign"}</div>
                  </Popover>
                }
              >
                <Button
                  style={buttonStyle}
                  onClick={(e) => {
                    e.stopPropagation();
                    assignTodo({
                      aTypeReadable: modelTodos[todo]?.text,
                      mNode: modelTodos[todo]
                    });
                  }}
                >
                  {/* {"Assign"} */}
                  <img src={TodoAssignIcon} />
                </Button>
              </OverlayTrigger>
              <OverlayTrigger
                placement="top"
                trigger={["hover"]}
                rootClose
                overlay={
                  <Popover id="popover-positioned-top">
                    <div>{"Pin"}</div>
                  </Popover>
                }
              >
                <Button
                  style={buttonStyle}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (pinnedHex && pinnedHex.id) {
                      updatePinnedHex(undefined);
                    } else {
                      updatePinnedHex(modelTodos[todo]);

                      handleBackModels(undefined, true);
                    }
                  }}
                  className={styles.pinButton}
                >
                  {/* {isPinned ? "Unpin" : "Pin"} */}
                  {isPinned ? (
                    <React.Fragment>
                      <img className={styles.pinNoHover} src={isPinned ? PinnedIcon : UnpinnedIcon} />
                      <img className={styles.pinHover} src={PinnedHoverIcon} />
                    </React.Fragment>
                  ) : (
                    <img style={{ width: "12px" }} src={UnpinnedIcon} />
                  )}
                </Button>
              </OverlayTrigger>
              {(todo === "REVIEW_MODEL_METRICS" || todo === "OPTIMIZE_COSTS" || todo === "OPTIMIZE_BALANCER") && (
                <Button style={buttonStyle} onClick={() => this.setState({ isExpand: !this.state.isExpand })}>
                  {this.state.isExpand ? "Collapse" : "Expand"}
                </Button>
              )}
              {(modelTodos[todo]?.hasUpdate || (isPinned && pinnedHex?.hasUpdate) || blueprintId === "new") &&
                modelTodos[todo]?.hideSave !== true && (
                  <Button
                    onClick={(e) => {
                      // Custom Formulas no longer tied to blueprints.
                      // if (todo === "OPTIMIZE_COSTS" && isEditBlueprint) {
                      //   return saveUpdateBlueprint();
                      // }
                      e.stopPropagation();

                      this.setState({ applyingUpdates: true }, () => {
                        console.log(this.state);
                        const updateNode = isPinned
                          ? pinnedHex
                          : modelTodos[todo]
                            ? modelTodos[todo]
                            : selectedHexModels;
                        handleUpdate(
                          {
                            x: updateNode,
                            y: updateNode
                          },
                          updateNode
                        ).then(() => {
                          this.setState({ applyingUpdates: false }, () =>
                            toast("Updates Applied!", {
                              type: toast.TYPE.SUCCESS,
                              position: toast.POSITION.TOP_CENTER,
                              autoClose: 3500
                            })
                          );
                        });
                      });
                    }}
                    style={{
                      padding: "3px"
                    }}
                    disabled={
                      (isCurrentDeployed || shouldSaveScenario) && todo === "DEPLOY_REVIEW"
                        ? true
                        : blueprintId !== undefined
                          ? false
                          : todo === "DEPLOY_REVIEW"
                            ? false
                            : !hasSetupChanged || this.state.applyingUpdates
                    }
                    type="primary"
                  >
                    {todo === "DEPLOY_REVIEW" ? (
                      deployment && !deployment.endpoint_url ? (
                        <React.Fragment>
                          <LoadingIndicator
                            style={{
                              width: "20px",
                              height: "18px",
                              transform: "scale(0.20)",
                              margin: "-5px 5px 5px -5px"
                            }}
                            color={"#FFFFFF"}
                          />
                          {"Deploying..."}
                        </React.Fragment>
                      ) : isCurrentDeployed ? (
                        "Deployed"
                      ) : (
                        "Deploy AI"
                      )
                    ) : (
                      "Update"
                    )}
                  </Button>
                )}
            </ButtonGroup>
          </div>
        </div>
        <div
          className={styles.todoBody}
          style={
            retIsMax && todo === "OPTIMIZE_COSTS"
              ? {
                  maxHeight: "calc(100vh - 220px)"
                }
              : retIsMax && (todo === "REVIEW_MODEL_METRICS" || todo === "REVIEW_MODEL_CHARTS")
                ? {
                    height: "calc(100vh - 220px)",
                    maxHeight: "100vh"
                  }
                : retIsMax
                  ? {
                      height: "calc(100vh - 220px)",
                      maxHeight: "100vh"
                    }
                  : { maxHeight: "0px" }
          }
        >
          {todo === "OPTIMIZE_BLUEPRINT" ? (
            <SelectDataWrapperContainer
              {...retProps}
              hideBlueprint
              isBlueprintPicker={true}
              type={wizardReducer.STEP_TYPE.ACADEMIC_REVIEW_DATASET.id}
              showCreateButton
              hidePicker={blueprintId === "new"}
              reportLabel={reportLabel}
              nextId={id}
            />
          ) : todo === "OPTIMIZE_TRANSACTION" ? (
            <RealityCheckContainer {...retProps} />
          ) : todo === "OPTIMIZE_BALANCER" ? (
            <OptimizeContainer {...retProps} isBalance />
          ) : todo === "OPTIMIZE_COSTS_BASELINE" ? (
            <BaselineCostsCardContainer {...retProps} />
          ) : todo === "OPTIMIZE_COSTS" ? (
            <div style={{ padding: "20px" }}>
              {blueprintId !== undefined && id === "new" ? (
                <AdvancedCostsContainer {...retProps} id={runId} blueprintId={blueprintId} isOptimizer />
              ) : optimized?.setup?.blueprintId !== undefined && isEditBlueprint !== true ? (
                <div>
                  <a className={styles.editLink} onClick={() => updateIsEditBlueprint(true)}>
                    {"Edit costs / benefits formulas"}
                  </a>
                  <StrategyContainer {...retProps} />
                </div>
              ) : optimized?.setup?.blueprintId !== undefined && isEditBlueprint === true ? (
                <div>
                  <a
                    className={styles.editLink}
                    style={{ marginBottom: "20px" }}
                    onClick={() => updateIsEditBlueprint(false)}
                  >
                    {"Return to costs / benefits"}
                  </a>
                  <AdvancedCostsContainer
                    {...retProps}
                    id={runId}
                    blueprintId={optimized?.setup?.blueprintId}
                    isOptimizer
                  />
                </div>
              ) : (
                <StrategyContainer {...retProps} />
              )}
            </div>
          ) : todo === "OPTIMIZE_STRATEGY" ? (
            <BusinessConstraintsContainer {...retProps} />
          ) : todo === "FAIR_GUIDE" ? (
            <ObjectiveContainer {...retProps} runId={overallRunId} />
          ) : todo === "FAIR_VALUE" || todo === "BUDGET_SUBGROUP" ? (
            <SubgroupContainer {...retProps} blueprintId={blueprintId} />
          ) : todo === "DEPLOY_INTEGRATION" ? (
            <IntegrateContainer {...retProps} />
          ) : todo === "DEPLOY_MONITOR" ? (
            <DeployContainer {...retProps} isAdvancedOptions />
          ) : todo === "DEPLOY_REVIEW" ? (
            <DeploySettingsContainer {...retProps} />
          ) : todo === "PREDICT_WHAT_IF" ? (
            <PredictContainer id={runId} runId={runId} projectId={projectId} isNext />
          ) : todo === "OUTCOME" ? (
            <SelectDataWrapperContainer
              {...retProps}
              hideBlueprint
              nextBlueprintId={blueprintId}
              type={wizardReducer.STEP_TYPE.ACADEMIC_REVIEW_DATASET.id}
              nextId={id}
            />
          ) : todo === "EVAL_MODEL_DRIVERS" ? (
            <ModelListContainer {...retProps} hideModelBox />
          ) : todo === "REVIEW_MODEL_METRICS" ? (
            <TrainContainer
              {...retProps}
              id={optimized && optimized.innerId !== undefined ? optimized.innerId : "new"}
              projectId={projectId}
              renderDetails
            />
          ) : todo === "REVIEW_MODEL_CHARTS" ? (
            <TrainContainer
              {...retProps}
              id={optimized && optimized.innerId !== undefined ? optimized.innerId : "new"}
              projectId={projectId}
            />
          ) : todo === "EVAL_MODEL_DRIVERS" ? (
            <ModelListContainer {...retProps} hideModelBox />
          ) : (
            <ModelListContainer {...retProps} hideModelBox />
          )}
        </div>
      </div>
    );
  }

  renderTaskSetup(taskObj) {
    const {
      id,
      datasetId,
      projectId,
      blueprintId,
      blueprint,
      runId,
      updateViewTask,
      rejectTask,
      approveTask,
      reportLabel,
      optimized,
      isNextBlueprintEdit
    } = this.props;

    const task = taskObj?.type;

    const retProps = {
      id: blueprintId === "new" ? "new" : blueprintId !== undefined && projectId === undefined ? runId : projectId,
      runId: blueprintId === "new" ? "new" : projectId === "new" ? "new" : runId,
      datasetId: datasetId,
      nextId: id,
      isNext: true,
      isModelsNext: true,
      hideModel: true,
      isNextBlueprintEdit: isNextBlueprintEdit,
      nextBlueprint: blueprint
    };

    const buttonStyle =
      blueprintId !== undefined
        ? { padding: "3px", fontWeight: "normal" }
        : {
            padding: "3px",
            color: "#7E69D7",
            fontWeight: "normal"
          };

    const retIsMax = true;
    const isList = false;

    return (
      <div className={styles.todoSection}>
        <div className={styles.todoHeaderStatic}>
          {task && (
            <div className={styles.hexIcon}>
              <img
                src={
                  task === "DEPLOY_REVIEW"
                    ? ReviewDeployIcon
                    : task === "DEPLOY_INTEGRATION"
                      ? IntegrateIcon
                      : task === "DEPLOY_MONITOR"
                        ? MonitorSettingsIcon
                        : task === "OPTIMIZE_STRATEGY"
                          ? BullseyeIcon
                          : task === "OPTIMIZE_TRANSACTION"
                            ? MiniFunnelIcon
                            : task === "OPTIMIZE_COSTS"
                              ? NewMoneyIcon
                              : task === "OPTIMIZE_BLUEPRINT"
                                ? WaypointIcon
                                : task === "PREDICT_WHAT_IF"
                                  ? StethoscopeIcon
                                  : task === "DEPLOY_REVIEW"
                                    ? LabVialIcon
                                    : task === "FAIR_GUIDE"
                                      ? ScalesIconWhiteBackground
                                      : task === "FAIR_VALUE"
                                        ? SecurityCheckIcon
                                        : task === "BUDGET_SUBGROUP"
                                          ? MicroscopeIcon
                                          : task === "BUDGET_RETRAIN"
                                            ? ReturnIcon
                                            : task === "EVAL_MODEL_DRIVERS"
                                              ? GearsIcon
                                              : task === "REVIEW_MODEL_METRICS"
                                                ? SpreadsheetIcon
                                                : task === "REVIEW_MODEL_CHARTS"
                                                  ? ChartIcon
                                                  : null
                }
              />
            </div>
          )}
          <div className={styles.todoText}>{readableSearch[task] || task}</div>
          <div className={styles.tActions}>
            <ButtonGroup>
              <Button
                style={buttonStyle}
                onClick={() => {
                  approveTask(taskObj);
                }}
              >
                {"Approve"}
              </Button>
              <Button
                style={buttonStyle}
                onClick={() => {
                  rejectTask(taskObj);
                }}
              >
                {"Reject"}
              </Button>
              <Button
                style={buttonStyle}
                onClick={() => {
                  updateViewTask(undefined);
                }}
              >
                {"Close"}
              </Button>
            </ButtonGroup>
          </div>
        </div>
        <div
          className={styles.todoBodyDisabled}
          style={
            retIsMax && task === "OPTIMIZE_COSTS"
              ? {
                  maxHeight: isList ? "calc(80vh - 200px)" : "calc(100vh - 220px)"
                }
              : retIsMax && (task === "REVIEW_MODEL_METRICS" || task === "REVIEW_MODEL_CHARTS")
                ? {
                    height: isList ? "calc(80vh - 200px)" : "calc(100vh - 220px)",
                    maxHeight: "100vh"
                  }
                : retIsMax
                  ? {
                      height: isList ? "calc(80vh - 200px)" : "calc(100vh - 220px)",
                      maxHeight: "100vh"
                    }
                  : { maxHeight: "0px" }
          }
        >
          {task === "OPTIMIZE_BLUEPRINT" ? (
            <SelectDataWrapperContainer
              {...retProps}
              hideBlueprint
              isBlueprintPicker={true}
              type={wizardReducer.STEP_TYPE.ACADEMIC_REVIEW_DATASET.id}
              showCreateButton
              hidePicker={blueprintId === "new"}
              reportLabel={reportLabel}
              nextId={id}
            />
          ) : task === "OPTIMIZE_TRANSACTION" ? (
            <RealityCheckContainer {...retProps} />
          ) : task === "OPTIMIZE_BALANCER" ? (
            <OptimizeContainer {...retProps} isBalance />
          ) : task === "OPTIMIZE_COSTS_BASELINE" ? (
            <BaselineCostsCardContainer {...retProps} />
          ) : task === "OPTIMIZE_COSTS" ? (
            <div style={{ padding: "20px" }}>
              <StrategyContainer {...retProps} />
            </div>
          ) : task === "OPTIMIZE_STRATEGY" ? (
            <BusinessConstraintsContainer {...retProps} />
          ) : task === "FAIR_GUIDE" ? (
            <ObjectiveContainer {...retProps} runId={overallRunId} />
          ) : task === "FAIR_VALUE" || task === "BUDGET_SUBGROUP" ? (
            <SubgroupContainer {...retProps} blueprintId={blueprintId} />
          ) : task === "DEPLOY_INTEGRATION" ? (
            <IntegrateContainer {...retProps} />
          ) : task === "DEPLOY_MONITOR" ? (
            <DeployContainer {...retProps} isAdvancedOptions />
          ) : task === "DEPLOY_REVIEW" ? (
            <DeploySettingsContainer {...retProps} />
          ) : task === "PREDICT_WHAT_IF" ? (
            <PredictContainer id={runId} runId={runId} projectId={projectId} isNext />
          ) : task === "OUTCOME" ? (
            <SelectDataWrapperContainer
              {...retProps}
              hideBlueprint
              nextBlueprintId={blueprintId}
              type={wizardReducer.STEP_TYPE.ACADEMIC_REVIEW_DATASET.id}
              nextId={id}
            />
          ) : task === "EVAL_MODEL_DRIVERS" ? (
            <ModelListContainer {...retProps} hideModelBox />
          ) : task === "REVIEW_MODEL_METRICS" ? (
            <TrainContainer
              {...retProps}
              id={optimized && optimized.innerId !== undefined ? optimized.innerId : "new"}
              projectId={projectId}
              renderDetails
            />
          ) : task === "REVIEW_MODEL_CHARTS" ? (
            <TrainContainer
              {...retProps}
              id={optimized && optimized.innerId !== undefined ? optimized.innerId : "new"}
              projectId={projectId}
            />
          ) : (
            task === "EVAL_MODEL_DRIVERS" && <ModelListContainer {...retProps} hideModelBox />
          )}
        </div>
      </div>
    );
  }

  renderViewTask() {
    const { viewTask } = this.props;

    return (
      <div
        className={styles.todos}
        style={viewTask === undefined ? { width: "0px", minWidth: "0px", border: "none" } : {}}
      >
        <div className={styles.todosHeader}>{"Viewing Task"}</div>
        <div className={styles.todoHolder}>{this.renderTaskSetup(viewTask)}</div>
      </div>
    );
  }

  renderModels() {
    const {
      id,
      projectId,
      runId,
      optimized,
      blueprintId,
      hasSplits,
      selectedHexModels,
      setupSection,
      pinnedHex,
      viewTask
    } = this.props;

    const rSetupSection = setupSection !== undefined ? setupSection : selectedHexModels?.leftSection;

    const pinnedPanelExists = pinnedHex && pinnedHex.id;

    return (
      <div className={styles.leftModels}>
        {hasSplits && (id !== "new" || optimized !== undefined) && (
          <SubgroupMenuContainer id={projectId} updateShow={() => {}} isNext nextId={id} />
        )}
        <div className={hasSplits && id !== "new" ? styles.splitModelBox : styles.modelBox} id="monitoringBox">
          <ModelBoxContainer
            id={projectId}
            runId={projectId === undefined ? "new" : runId}
            isNext
            nextId={id}
            background={blueprintId !== undefined ? "rgb(74, 144, 226)" : undefined}
          />
        </div>
        {/*PINNED PANEL STUFF*/}
        {this.renderViewTask()}
        {viewTask === undefined &&
          selectedHexModels &&
          selectedHexModels?.selected === undefined &&
          (pinnedHex?.id === undefined || pinnedHex?.id !== selectedHexModels?.id) && (
            <div
              className={styles.leftSetup}
              style={
                pinnedPanelExists
                  ? { left: "66.66vw" }
                  : this.state.isExpand &&
                      (selectedHexModels?.id === "REVIEW_MODEL_METRICS" ||
                        selectedHexModels?.id === "OPTIMIZE_COSTS" ||
                        selectedHexModels?.id === "OPTIMIZE_BALANCER")
                    ? { width: "66.66vw", maxWidth: "66.66vw" }
                    : {}
              }
            >
              {this.renderTodo(selectedHexModels?.id, true)}
            </div>
          )}
        {pinnedPanelExists && (
          <div
            className={styles.lSectionPinned}
            style={
              this.state.isExpand &&
              (pinnedHex?.id === "REVIEW_MODEL_METRICS" ||
                pinnedHex?.id === "OPTIMIZE_COSTS" ||
                pinnedHex?.id === "OPTIMIZE_BALANCER")
                ? { width: "66.66vw", maxWidth: "66.66vw" }
                : rSetupSection === "BLUEPRINT"
                  ? {}
                  : {}
            }
          >
            {pinnedHex ? this.renderTodo(pinnedHex?.id, true, pinnedHex, true) : <div />}
          </div>
        )}
      </div>
    );
  }

  renderGuideModal = () => {
    const { isGuided, updateIsGuided } = this.props;
    const closeModal = () => {
      updateIsGuided(false);
    };
    const showModal = Boolean(this.state.showGuideModal && isGuided);
    return (
      <Dialog
        open={showModal}
        onOpenChange={() => {
          closeModal();
        }}
      >
        <DialogContent size="full">
          <DialogHeader>
            <DialogTitle>Welcome to the Data Exporation</DialogTitle>
          </DialogHeader>
          <div>
            <div style={{ marginTop: "10px" }}>
              The guidance is now focused on the selected option with recommended steps listed around it. Select one of
              the actions to proceed.
            </div>
            <div style={{ marginTop: "10px" }}>
              To see a summary of all the work done for this project click on the overview tab above or the smaller
              overview map on the bottom right.
            </div>
          </div>
          <DialogFooter>
            <Button onClick={() => closeModal()}>Close</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    );
  };

  renderReviewingJob = () => {
    const { history, updateIsReviewingJob } = this.props;

    const returnToMarket = () => {
      updateIsReviewingJob(false);
      history.push("/market/");
    };

    return (
      <div className={styles.screenBlur}>
        <div className={styles.reviewBar}>
          <div className={styles.reviewBarLeft}>
            <Button type="secondary" onClick={() => returnToMarket()} style={{ marginRight: "10px" }}>
              Return
            </Button>
            Ready to accept and review the finished work? Complete the consultants payment to unlock.
          </div>
          <div className={styles.reviewBarRight}>
            <div className={styles.reviewBarRightPrice}>
              <div style={{ fontWeight: "bold" }}>$1,020.00</div>
              <div>12 HOURS @ $85/HR</div>
            </div>
            <Button type="primary" onClick={() => updateIsReviewingJob(false)}>
              Pay and Unlock
            </Button>
          </div>
        </div>
      </div>
    );
  };

  handleHexClick(node) {
    const { updateSelectionDirection, updateSelectedChart, selectedChart } = this.props;

    const isDirectionNode = node?.isDirection;
    const hex = { x: node?.x, y: node?.y };

    const isSelectedChart =
      selectedChart?.chart?.title !== undefined && selectedChart?.chart?.title === node?.chart?.title;

    return isSelectedChart
      ? () => {}
      : isDirectionNode
        ? updateSelectionDirection(node, true)
        : updateSelectedChart(hex, node);
  }

  getIconFromType(type) {
    const icon =
      type === nextReducer.HEXAGON_NODES.SECOND_VARIABLE
        ? SecondVarIcon
        : type === nextReducer.HEXAGON_NODES.STAT_ASSOC
          ? StatAssocIcon
          : type === nextReducer.HEXAGON_NODES.POPULAR
            ? PopularIcon
            : type === nextReducer.HEXAGON_NODES.VOTING
              ? VotingIcon
              : type === nextReducer.HEXAGON_NODES.DRILL_IN_CLUSTER
                ? SecondVarIcon
                : type === nextReducer.HEXAGON_NODES.DRILL_IN
                  ? FirstVarIcon
                  : type === nextReducer.HEXAGON_NODES.FIRST_VARIABLE
                    ? FirstVarIcon
                    : FirstVarIcon;

    return icon;
  }

  renderRelate(node, style, fromType = undefined, isHideRank = false) {
    const pType = fromType !== undefined ? fromType : node?.fromType?.type;

    const background =
      pType === nextReducer.HEXAGON_NODES.DRILL_IN || pType === nextReducer.HEXAGON_NODES.DRILL_IN_CLUSTER
        ? node?.parent?.fields?.[0]?.color || node?.fields?.[0]?.color
        : "rgb(126, 105, 215)";
    const icon = this.getIconFromType(pType);

    return (
      <div className={styles.relateInfoN} style={style ? style : {}}>
        <div className={styles.relateBox} style={{ background: background }}>
          {pType !== undefined && node?.rIndex !== undefined && isHideRank !== true && (
            <div className={styles.scoreRankNum}>{node?.rIndex + 1}</div>
          )}
          <img className={styles.relateIcon} src={icon} />
        </div>
      </div>
    );
  }

  renderTinyScore(node) {
    const { id } = this.props;

    return (
      <div className={styles.tinyMuscleScore}>
        <LeakageChartContainer id={id} height={110} width={110} innerRadius={13} node={node} isTiny hideChords />
        <div className={styles.tinyScore}>{node?.chart?.scoreRank + 1}</div>
      </div>
    );
  }

  renderTopText(node) {
    const { dataset } = this.props;

    const outcome = dataset?.outcome;

    const nText =
      node?.chart?.scoreRank === 0
        ? "strongest"
        : node?.chart?.scoreRank === 1
          ? "second largest"
          : node?.chart?.scoreRank === 2
            ? "third largest"
            : node?.chart?.scoreRank === 3
              ? "fourth largest"
              : node?.chart?.scoreRank === 4
                ? "fifth largest"
                : node?.chart?.scoreRank === 5
                  ? "sixth largest"
                  : "weakeast";

    return node?.chart?.metadata?.type === "ModelDriver" && node?.chart?.narrative?.topText ? (
      <div className={styles.tinyScoreText}>
        <span>{node?.chart?.narrative?.topText}</span>
      </div>
    ) : (
      <div className={styles.tinyScoreText}>
        <span style={{ fontWeight: "bold" }}>{node?.fields?.[0]?.label}</span>
        <span style={{ marginLeft: "3px" }}>{"has the " + nText + " relationship with"}</span>
        <span style={{ fontWeight: "bold", marginLeft: "3px" }}>{outcome}</span>
      </div>
    );
  }

  renderRelateText(node) {
    return node?.rIndex === undefined ? (
      <div />
    ) : (
      <div className={styles.relateText}>
        <span>{node?.chart?.narrative?.topText}</span>
      </div>
    );
  }

  renderTinyMuscle(node) {
    const { id } = this.props;

    return (
      <div className={styles.tinyMuscleChart}>
        <LeakageChartContainer id={id} height={125} width={125} node={node} insight={node?.chart} isTiny />
      </div>
    );
  }

  renderTinyScoreEmpty() {
    return <div className={styles.tinyMuscleScore} style={{ width: "50px" }}></div>;
  }

  renderComboCount() {
    const { interactionsEvaluated } = this.props;

    if (!interactionsEvaluated) {
      return null;
    }

    return (
      <div className={styles.nextSubtitle} style={{ marginTop: "0px" }}>
        <div className={styles.exploreCombinationBadge} style={{ marginBottom: "0px" }}>
          <Icon size={18} src={RadarIcon} />
          <div
            style={{
              marginLeft: "6px",
              paddingRight: "6px",
              lineHeight: "10px"
            }}
          >
            <strong>{numeral(interactionsEvaluated).format("0,0")}</strong>
            <span>{" combinations automatically evaluated"}</span>
          </div>
        </div>
      </div>
    );
  }

  renderNextList() {
    const {
      id,
      hexMap,
      actionHexMap,
      selectedHex,
      updateSelectedHex,
      isTodo,
      rSetupSection,
      searchInsights,
      searchOptions,
      resetActions,
      updateHover,
      removeNode,
      addNode,
      pinnedHexList,
      selectionDirectionCharts,
      selectionDirection,
      selectedChart,
      optimized
    } = this.props;

    const hasModels = optimized?.bestModel !== undefined;

    const rHexMap = hexMap ? Object.keys(hexMap).filter((hKey) => hKey !== "8_8") : [];

    const allChartsFull = [];
    const allCharts = [];

    const showSearch = searchInsights && searchInsights.length > 0 && searchOptions && searchOptions.length > 0;

    if (showSearch) {
      searchInsights.forEach((sChart) => {
        allCharts.push({ ...sChart, chart: { ...sChart } });
      });

      rHexMap.forEach((hKey) => {
        const nodes = hexMap[hKey];

        if (Array.isArray(nodes)) {
          nodes.forEach((n) => {
            allChartsFull.push(n);
          });
        }
      });
    } else {
      pinnedHexList.forEach((node) => {
        allChartsFull.push(node);
        allCharts.push({ ...node, isTopChart: true });
      });
    }

    const retStyle =
      isTodo !== true || rSetupSection === undefined ? {} : { maxWidth: "33.33vw", marginLeft: "33.33vw" };

    return (
      <div className={styles.modelList} style={retStyle}>
        <div className={styles.listTitle} style={{ display: "flex", alignItems: "center" }}>
          {allCharts && allCharts.length > 0
            ? allCharts.length + " Insights Found"
            : "What Insights are you Interested in Exploring?"}
          {this.renderComboCount()}
        </div>
        {allCharts.map((node, i) => {
          const renderIcons = true;

          const isNodeSelected = selectedHex && selectedHex?.chart?.narrative?.title === node?.chart?.narrative?.title;

          const isNodeSelectedChart =
            selectedChart && selectedChart?.chart?.narrative?.title === node?.chart?.narrative?.title;

          const isNodeInReport =
            allChartsFull.find((rChart) => rChart?.chart?.narrative?.title === node?.chart?.narrative?.title) !==
            undefined;

          const isSelectedC =
            node?.chart?.narrative?.title && node?.chart?.narrative?.title === selectedChart?.chart?.narrative?.title;

          const aNodes = Object.keys(actionHexMap)
            .filter((aKey) => actionHexMap[aKey] !== undefined)
            .filter((aKey) => actionHexMap[aKey].isDirection === true)
            .map((aKey) => actionHexMap[aKey]);

          return (
            <div
              key={"bNode_" + node?.chart?.narrative?.title + "_" + i}
              className={styles.listNode}
              style={
                isNodeSelected || isNodeSelectedChart
                  ? { border: "1px solid #7E69D7" }
                  : node?.isRelated
                    ? { borderBottom: "none" }
                    : {}
              }
            >
              <div
                id={"nextListChart_" + i}
                className={styles.innerListNode}
                style={
                  isSelectedC ? { background: "rgb(230, 229, 250)" } : node?.isRelated ? { marginLeft: "40px" } : {}
                }
                onClick={
                  showSearch
                    ? (e) => {
                        e.stopPropagation();

                        this.handleHexClick(node);
                      }
                    : (e) => {
                        e.stopPropagation();

                        if (
                          selectedHex?.chart !== undefined &&
                          selectedHex?.chart?.narrative?.title === node?.chart?.narrative?.title
                        ) {
                          resetActions(false);
                        } else if (selectedHex?.chart !== undefined) {
                          //resetActions(false);
                          updateSelectedHex(node);
                        } else {
                          updateSelectedHex(node);
                        }
                      }
                }
                onMouseEnter={() => {
                  updateHover(node);
                }}
                onMouseLeave={() => {
                  updateHover(undefined);
                }}
              >
                {showSearch !== true && (
                  <div className={styles.showAcc} style={isNodeSelected ? { opacity: 1 } : {}}>
                    <FontAwesomeIcon icon={isNodeSelected ? faChevronUp : faChevronDown} />
                  </div>
                )}
                <div
                  id={"closeButton"}
                  style={{ height: "0px", width: "0px", pointerEvents: "none" }}
                  onClick={() => resetActions(false)}
                />
                <div className={styles.listActions}>
                  {isNodeInReport ? (
                    <OverlayTrigger
                      placement="top"
                      trigger={["hover"]}
                      rootClose
                      overlay={
                        <Popover id="popover-positioned-top">
                          <div>{"Unpin Chart"}</div>
                        </Popover>
                      }
                    >
                      <Button
                        onClick={(e) => {
                          e.stopPropagation();

                          removeNode(
                            {
                              x: node.x,
                              y: node.y
                            },
                            node
                          );
                        }}
                        style={{ padding: "5px" }}
                        className={styles.pinButton}
                      >
                        <img src={PinnedHoverIcon} className={styles.pinHover} />
                        <img src={PinnedIcon} className={styles.pinNoHover} />
                      </Button>
                    </OverlayTrigger>
                  ) : (
                    <OverlayTrigger
                      placement="top"
                      trigger={["hover"]}
                      rootClose
                      overlay={
                        <Popover id="popover-positioned-top">
                          <div>{"Add Chart"}</div>
                        </Popover>
                      }
                    >
                      <Button
                        id={"pinButton"}
                        onClick={(e) => {
                          e.stopPropagation();

                          return addNode(node);
                        }}
                        style={{ padding: "3px" }}
                      >
                        <img src={UnpinnedIcon} className={styles.fPin} />
                      </Button>
                    </OverlayTrigger>
                  )}
                </div>
                {this.renderTinyMuscle(node)}
                <div className={styles.miniHex}>
                  <NextChartContainer id={id} chart={node?.chart} isSmall isListChart />
                </div>
                {showSearch ? (
                  <div />
                ) : node?.chart?.metadata?.type === "ModelDriver" &&
                  node?.chart?.metadata?.properties &&
                  node.chart?.metadata.properties.length === 2 ? (
                  this.renderTinyScoreEmpty()
                ) : renderIcons &&
                  node?.fields &&
                  Object.keys(node?.fields).length === 1 &&
                  node?.isAction !== true &&
                  node?.chart?.scoreRank !== undefined ? (
                  this.renderTinyScore(node)
                ) : (
                  this.renderRelate(node)
                )}
                <div className={styles.nHolder}>
                  <div className={styles.listChartTitle}>{node?.chart?.title}</div>
                  {showSearch ? (
                    <div />
                  ) : node?.fields &&
                    Object.keys(node?.fields).length === 1 &&
                    node?.isAction !== true &&
                    node?.chart?.scoreRank !== undefined ? (
                    this.renderTopText(node)
                  ) : node?.rIndex !== undefined && node?.rIndex > 5 ? (
                    <div />
                  ) : (
                    this.renderRelateText(node)
                  )}
                </div>
              </div>
              <div
                className={styles.childNodeList}
                style={
                  isNodeSelected
                    ? {
                        maxHeight:
                          selectionDirection !== undefined && selectionDirectionCharts
                            ? selectionDirectionCharts.length * 100 + 40 + "px"
                            : hasModels
                              ? "1100px"
                              : "800px",
                        height:
                          selectionDirection !== undefined && selectionDirectionCharts
                            ? selectionDirectionCharts.length * 100 + 40 + "px"
                            : hasModels
                              ? "1100px"
                              : "800px",
                        overflow: "hidden"
                      }
                    : { height: "0px", overflow: "hidden" }
                }
              >
                {actionHexMap &&
                  selectedHex?.x === node?.x &&
                  selectedHex?.y === node?.y &&
                  selectedHex?.chart?.title === node?.chart?.title &&
                  aNodes.map((actionNode, j) => {
                    const childNodes =
                      selectionDirection !== undefined && selectionDirectionCharts
                        ? selectionDirectionCharts
                        : Object.keys(actionHexMap)
                            .filter(
                              (aKey) =>
                                actionHexMap[aKey]?.parent?.type &&
                                actionHexMap[aKey]?.parent?.type === actionNode?.type
                            )
                            .map((aKey) => actionHexMap[aKey]);

                    const firstVariable = actionNode?.fields?.[0]?.label;
                    const secondVariable = actionNode?.fields?.[1]?.label;

                    return (
                      <div
                        id={"directionSection_" + j}
                        key={"action_" + (actionNode?.chart?.narrative?.title || actionNode?.type) + "_" + j}
                      >
                        <div
                          onClick={(e) => {
                            e.stopPropagation();

                            this.handleHexClick(actionNode);
                            this.setState({
                              showAll: this.state.showAll
                                ? undefined
                                : actionNode?.chart?.metadata?.properties?.[0]?.column + "_@_" + actionNode?.type
                            });
                          }}
                          className={styles.listActionSection}
                        >
                          <div
                            className={styles.directionNodeText}
                            style={childNodes && childNodes.length === 0 ? { paddingBottom: "40px" } : {}}
                          >
                            {this.renderRelate(
                              node,
                              { marginRight: "10px", marginLeft: "0px" },
                              actionNode?.type,
                              true
                            )}
                            {actionNode?.type === nextReducer.HEXAGON_NODES.DRILL_IN
                              ? "Drill-down on " + firstVariable
                              : actionNode?.type === nextReducer.HEXAGON_NODES.DRILL_IN_CLUSTER
                                ? "Benchmark (group by) a specific " + firstVariable
                                : actionNode?.type === nextReducer.HEXAGON_NODES.FIRST_VARIABLE
                                  ? "Continue exploring " + firstVariable + " insights"
                                  : actionNode?.type === nextReducer.HEXAGON_NODES.SECOND_VARIABLE
                                    ? "Skip to learning more about " + secondVariable
                                    : actionNode?.type === nextReducer.HEXAGON_NODES.STAT_ASSOC
                                      ? "What is statistically related to " + firstVariable
                                      : actionNode?.type === nextReducer.HEXAGON_NODES.VOTING
                                        ? "Importance according to different models"
                                        : ""}
                            {childNodes && childNodes.length > 0 && (
                              <div>
                                <a
                                  className={styles.relatedLink}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    this.handleHexClick(actionNode);
                                    this.setState({
                                      showAll:
                                        this.state.showAll ===
                                        actionNode?.chart?.metadata?.properties?.[0]?.column + "_@_" + actionNode?.type
                                          ? undefined
                                          : actionNode?.chart?.metadata?.properties?.[0]?.column +
                                            "_@_" +
                                            actionNode?.type
                                    });
                                  }}
                                >
                                  {this.state.showAll ===
                                  actionNode?.chart?.metadata?.properties?.[0]?.column + "_@_" + actionNode?.type
                                    ? "Hide All"
                                    : "Show All"}
                                </a>
                              </div>
                            )}
                          </div>
                        </div>
                        {childNodes &&
                          childNodes.map((childNode, j) => {
                            const isInReport =
                              allCharts.find(
                                (rChart) => rChart?.chart?.narrative?.title === childNode?.chart?.narrative?.title
                              ) !== undefined;

                            const isSelectedChild =
                              childNode?.chart?.narrative?.title &&
                              childNode?.chart?.narrative?.title === selectedChart?.chart?.narrative?.title;

                            return (
                              <div
                                key={"childNode_" + childNode?.chart?.narrative?.title + "_" + j}
                                className={styles.actionNode}
                                onClick={(e) => {
                                  e.stopPropagation();

                                  this.handleHexClick(childNode);
                                }}
                                style={isSelectedChild ? { background: "rgb(230, 229, 250)" } : {}}
                              >
                                <div className={styles.listActionsC}>
                                  <div className={styles.listActionsChild}>
                                    {isInReport ? (
                                      <OverlayTrigger
                                        placement="top"
                                        trigger={["hover"]}
                                        rootClose
                                        overlay={
                                          <Popover id="popover-positioned-top">
                                            <div>{"Unpin Chart"}</div>
                                          </Popover>
                                        }
                                      >
                                        <Button
                                          onClick={(e) => {
                                            e.stopPropagation();

                                            removeNode(
                                              {
                                                x: childNode.x,
                                                y: childNode.y
                                              },
                                              childNode
                                            );
                                          }}
                                          style={{ padding: "5px" }}
                                          className={styles.pinButton}
                                        >
                                          <img src={PinnedHoverIcon} className={styles.pinHover} />
                                          <img src={PinnedIcon} className={styles.pinNoHover} />
                                        </Button>
                                      </OverlayTrigger>
                                    ) : (
                                      <OverlayTrigger
                                        placement="top"
                                        trigger={["hover"]}
                                        rootClose
                                        overlay={
                                          <Popover id="popover-positioned-top">
                                            <div>{"Add Chart"}</div>
                                          </Popover>
                                        }
                                      >
                                        <Button
                                          id={"pinButton"}
                                          onClick={(e) => {
                                            e.stopPropagation();

                                            return addNode(childNode);
                                          }}
                                          style={{ padding: "3px" }}
                                        >
                                          <img src={UnpinnedIcon} className={styles.fPin} />
                                        </Button>
                                      </OverlayTrigger>
                                    )}
                                  </div>
                                </div>
                                <div className={styles.indentIcon}>
                                  <img src={IndentIcon} />
                                </div>
                                {this.renderTinyMuscle(childNode)}

                                <div className={styles.miniHex}>
                                  <NextChartContainer id={id} chart={childNode?.chart} isSmall isListChart />
                                </div>
                                <div className={styles.nHolder}>
                                  <div className={styles.listChartTitle}>{childNode?.chart?.title}</div>
                                  {childNode?.fields &&
                                  Object.keys(childNode?.fields).length === 1 &&
                                  childNode?.isAction !== true &&
                                  childNode?.chart?.scoreRank !== undefined ? (
                                    this.renderTopText(childNode)
                                  ) : childNode?.rIndex !== undefined && childNode?.rIndex > 5 ? (
                                    <div />
                                  ) : (
                                    this.renderRelateText(childNode)
                                  )}
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    );
                  })}
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  renderList() {
    const { id, blueprintId, setupSection, selectedHexModels, isTodo, activeTab } = this.props;

    const rSetupSection = setupSection !== undefined ? setupSection : selectedHexModels?.leftSection;

    return (
      <div
        id={"hexListScroll"}
        className={activeTab === "EXPLORE" ? styles.hexListExplore : styles.hexList}
        style={
          activeTab === "EXPLORE"
            ? {
                left: "min(700px, max(40vw, 600px))",
                width: "max(calc(100vw - 700px), min(60vw, calc(100vw - 600px)))"
              }
            : activeTab === "MODELS"
              ? { left: "max(33.33vw, 500px)", width: "66.66vw" }
              : {}
        }
      >
        {activeTab === "MODELS" ? (
          <ModelsContainer
            id={id}
            isList
            isTodo={isTodo}
            rSetupSection={isTodo ? "TODOS" : rSetupSection}
            blueprintId={blueprintId}
          />
        ) : (
          this.renderNextList()
        )}
      </div>
    );
  }

  getInitialsFromText(text) {
    if (text === undefined) {
      return undefined;
    }

    const matches = text.match(/\b(\w)/g);
    return matches.join("").substring(0, 3);
  }

  renderComment(comment, index) {
    return (
      <div key={index} className={styles.innerComment}>
        <div className={styles.commentTitle}>{comment?.title}</div>
        <div className={styles.commentStatus}>
          <div className={styles.assignCircle}>{this.getInitialsFromText(comment?.created_by?.fullname)}</div>
          <div>{comment?.created_by?.fullname}</div>
          <div
            className={styles.commentDate}
            title={moment.utc(comment?.created_date).local().format("MMMM Do YYYY, h:mm:ss a")}
          >
            {moment.utc(comment?.created_date).local().fromNow()}
          </div>
        </div>
        <div className={styles.commentText}>{comment?.message}</div>
      </div>
    );
  }

  renderComments() {
    const { activeTab, exploreTasks, tasks } = this.props;

    const { isShowComments } = this.state;

    let combined = [];

    if (activeTab === "EXPLORE") {
      exploreTasks &&
        exploreTasks
          .filter((t) => t?.id === isShowComments?.id)
          .forEach((t) => t?.comments && t?.comments.forEach((c) => combined.push(c)));
    } else if (activeTab === "MODELS") {
      tasks &&
        tasks
          .filter((t) => t?.id === isShowComments?.id)
          .forEach((t) => t?.comments && t?.comments.forEach((c) => combined.push(c)));
    }

    const task = isShowComments;

    return (
      <React.Fragment>
        <div className={styles.innerCommentHeader}>
          <FontAwesomeIcon icon={faComments} style={{ marginRight: "10px" }} />
          {"Comments and Feedback"}
        </div>
        <div className={styles.commentList}>
          {combined.length === 0 ? (
            <div className={styles.emptyComments}>{"No Comments or Feedback found"}</div>
          ) : (
            <div>
              {[...combined]
                .sort((a, b) =>
                  moment(a.created_date).isBefore(moment(b.created_date))
                    ? 1
                    : moment(b.created_date).isBefore(moment(a.created_date))
                      ? -1
                      : 0
                )
                .map((c, i) => this.renderComment(c, i))}
            </div>
          )}
        </div>
        <div className={styles.newComment}>
          <CommentModalContainer id={task?.id} nextId={task?.nextId} isNoModal isNext task={task} />
        </div>
      </React.Fragment>
    );
  }

  renderTask(task, index) {
    const { updateViewTask, deleteTask, activeTab, approveTaskProject } = this.props;

    const { isShowComments } = this.state;

    const status =
      task?.status === "ACCEPTED"
        ? "Approved"
        : task?.status === "REJECTED"
          ? "Rejected"
          : (task?.versions && task?.versions.length > 0) ||
              (task?.comment_count > 0 && task?.type === "EVAL_MODEL_DRIVERS")
            ? "Pending"
            : "Not Started";

    const isShowCurrentComments = isShowComments?.id !== undefined && isShowComments?.id === task?.id;

    return (
      <div
        key={index + "_" + task?.id}
        className={styles.comment}
        style={index % 2 === 0 ? { background: "rgba(236, 236, 252, 1)" } : {}}
      >
        <div className={styles.commentTitle}>{readableSearch[task?.type] || task?.type}</div>
        <div className={styles.commentStatus}>
          <div className={styles.assignCircle}>{this.getInitialsFromText(task?.assigned_to?.fullname)}</div>
          <div>{task?.assigned_to?.fullname}</div>
          <div
            className={styles.commentDate}
            title={moment.utc(task?.created_date).local().format("MMMM Do YYYY, h:mm:ss a")}
          >
            {moment.utc(task?.created_date).local().fromNow()}
          </div>
        </div>
        <div className={styles.commentText}>{task?.description}</div>
        {activeTab === "MODELS" && <div className={styles.commentText}>{"Status: " + status}</div>}
        <div className={styles.commentText}>
          {(task?.like_count === 0 ? "" : task?.like_count + (task?.like_count === 1 ? " like" : "likes")) +
            (task?.dislike_count === 0
              ? ""
              : (task?.like_count > 0 ? ", " : "") +
                task?.dislike_count +
                (task?.dislike_count === 1 ? " dislike " : " dislikes "))}
        </div>
        <div className={styles.commentButtons}>
          <ButtonGroup>
            <Button onClick={() => approveTaskProject(task?.id)} disabled={task?.status === "ACCEPTED"}>
              {"Mark Complete"}
            </Button>
            <Button
              onClick={() => updateViewTask(task)}
              disabled={task?.versions === undefined || task?.versions.length === 0}
            >
              {task?.versions === undefined || task?.versions.length === 0 ? "Not Started" : "View"}
            </Button>
            <Button
              onClick={() =>
                this.setState({
                  isShowComments: isShowCurrentComments ? undefined : task
                })
              }
              active={isShowCurrentComments}
            >
              <FontAwesomeIcon icon={faComments} style={{ marginRight: "3px" }} />
              {task?.comments ? task.comments.length : "0"}
            </Button>
            <Button onClick={() => deleteTask(task?.id)}>
              <FontAwesomeIcon icon={faTrash} />
            </Button>
          </ButtonGroup>
        </div>
        {isShowCurrentComments && <div className={styles.innerComments}>{this.renderComments()}</div>}
      </div>
    );
  }

  renderTasks() {
    const { exploreTasks, tasks, activeTab } = this.props;

    const bTasks = activeTab === "EXPLORE" ? exploreTasks : tasks;
    const retTasks = [...bTasks]
      .filter((a) => a.deleted !== "DELETED")
      .sort((a, b) =>
        moment(a.created_date).isBefore(moment(b.created_date))
          ? 1
          : moment(b.created_date).isBefore(moment(a.created_date))
            ? -1
            : 0
      );

    return (
      <React.Fragment>
        <div className={styles.commentHeader}>
          <FontAwesomeIcon icon={faUsers} style={{ marginRight: "10px" }} />
          {"Created Tasks"}
        </div>
        <div className={styles.commentList}>
          {retTasks && retTasks.length > 0 ? (
            retTasks.map((task, i) => this.renderTask(task, i))
          ) : (
            <div className={styles.taskEmptyMsg}>{"You have no tasks."}</div>
          )}
        </div>
      </React.Fragment>
    );
  }

  getIsAutoHideMinimap() {
    const { pinnedHex, selectedHexModels, activeTab } = this.props;

    const isModelsPanel = activeTab === "MODELS";

    const pinnedPanelExists = pinnedHex && pinnedHex.id;
    const leftPanelExists = selectedHexModels?.selected === undefined;

    const isExpanded = this.state.isExpand;

    return isModelsPanel && ((pinnedPanelExists && leftPanelExists) || (leftPanelExists && isExpanded));
  }

  renderHeader() {
    const {
      id,
      projectId,
      dataset,
      datasetId,
      blueprintId,
      blueprint,
      isSavingReport,
      saveAsPpt,
      isTasks,
      hexMap,
      saveNext,
      reportLabel,
      allScenarios,
      exportToPowerpointProject,
      project,
      updateReportLabel,
      updateActiveTab,
      updateIsTasks,
      activeTab,
      saveBlueprint,
      optimized,
      hasSetupIgnoreChanged,
      isRetraining,
      retrainRun,
      tasks,
      exploreTasks,
      comparisonOptions,
      updateExploreDefaultViewMode,
      exploreDefaultViewMode,
      chatGPTShowSettings,
      chatGPTUpdateShowSettings,
      isShareLink,
      history,
      isSmallScreen,
      chatRestrictChartsToPinned,
      updateChatRestrictChartsToPinned,
      previousReportData,
      modelGroups,
      segmentSetups
    } = this.props;
    const { shouldSaveProject, isList, manualSaving } = this.state;

    const isNewBlueprint = blueprintId === "new";

    const hasDataset = dataset !== undefined && datasetId > 0;
    const hasOutcome = hasDataset && dataset?.outcome;

    const hasHexes = hexMap && Object.keys(hexMap)?.length > 0;

    const hasPendingTasks =
      activeTab === "MODELS" && tasks
        ? tasks.filter((task) => task?.status === "DRAFT" && task?.versions && task.versions.length > 0).length > 0
        : activeTab === "EXPLORE" && exploreTasks
          ? exploreTasks.filter(
              (task) => task?.status === "DRAFT" && task?.type === "EXPLORE_CHART" && task?.comment_count > 0
            ).length > 0
          : false;

    const IS_SIMPLE_MODE = true;

    return (
      <div className={styles.nextHeader}>
        <div className={styles.reportTitle}>
          {reportLabel && (
            <ShadcnTooltip>
              <TooltipTrigger asChild>
                <div className={styles.titleHover}>
                  <img className={styles.titleEdit} src={EditIcon} alt={"Edit"} />
                  <LineInput
                    isMediumBox
                    isCleanEditable
                    style={{ width: "100%" }}
                    value={reportLabel}
                    onChange={(val) => {
                      this.setState({
                        shouldSaveProject: true
                      });
                      if (val.length) updateReportLabel(val);
                      else updateReportLabel("My Untitled Project");
                    }}
                    isLocked={isShareLink}
                    placeholder={reportLabel ? reportLabel : isNewBlueprint ? "Blank Use Case" : "My Untitled Project"}
                  />
                </div>
              </TooltipTrigger>
              <TooltipContent className="z-[5000]">{reportLabel}</TooltipContent>
            </ShadcnTooltip>
          )}
        </div>
        {!isShareLink && !isSmallScreen ? (
          <NextHeaderTabs id={id} blueprintId={blueprintId} previousReportData={previousReportData} />
        ) : (
          <div className={styles.centerHeader} />
        )}
        {isShareLink && <div style={{ flexGrow: 1 }} />}

        {(activeTab === "CHATGPT" || activeTab === "NLQ Dashboard") &&
          !isEnabled("spark-agents-templates-view") &&
          isEnabled("model-fine-tuning") &&
          !isShareLink &&
          !isSmallScreen && <FineTuningButton />}
        {(isEnabled("aible-explore") || isEnabled("aible-optimize") || isEnabled("chat-aible-advanced-controls")) &&
          (activeTab === "EXPLORE" ||
            activeTab === "DASHBOARD" ||
            activeTab === "CHATGPT" ||
            activeTab === "NLQ Dashboard") && (
            <ButtonGroup>
              {!IS_SIMPLE_MODE && isEnabled("aible-dashboard") && !isShareLink && !isSmallScreen && (
                <Tooltip
                  overlay={
                    hasHexes
                      ? hasOutcome
                        ? "Show Dashboard"
                        : "Select an outcome on the dataset to generate dashboard"
                      : "Dashboard is unavailable"
                  }
                  placement={"bottom"}
                  trigger={["hover"]}
                >
                  <Button
                    active={activeTab === "DASHBOARD"}
                    onClick={() => updateActiveTab("DASHBOARD")}
                    disabled={!hasOutcome || !hasHexes}
                  >
                    <div className={styles.bFlex}>
                      <Icon size={16} src={ChartIcon} />
                    </div>
                  </Button>
                </Tooltip>
              )}
              {(isEnabled("next-list-view") || (isEnabled("classic-view") && projectId !== undefined)) &&
                !isShareLink &&
                !isSmallScreen && (
                  <Tooltip
                    overlay={
                      hasHexes
                        ? hasOutcome
                          ? "Show Hexes"
                          : "Select an outcome on the dataset to generate hexes"
                        : "Hex view is unavailable"
                    }
                    placement={"bottom"}
                    trigger={["hover"]}
                  >
                    <Button
                      active={
                        !isList && activeTab !== "DASHBOARD" && activeTab !== "CHATGPT" && activeTab !== "NLQ Dashboard"
                      }
                      onClick={() => {
                        this.handleUpdateIsList(false);

                        if (activeTab === "DASHBOARD" || activeTab === "CHATGPT" || activeTab === "NLQ Dashboard") {
                          updateActiveTab("EXPLORE");
                        }
                      }}
                      disabled={!hasOutcome || !hasHexes}
                    >
                      <div className={styles.bFlex}>
                        <Icon size={16} src={HexViewHeaderIcon} />
                      </div>
                    </Button>
                  </Tooltip>
                )}
              {isEnabled("next-list-view") &&
                isEnabled("next-easy") &&
                !comparisonOptions?.dateField &&
                !isShareLink &&
                !isSmallScreen && (
                  <Tooltip
                    overlay={
                      hasHexes
                        ? hasOutcome
                          ? "Show List"
                          : "Select an outcome on the dataset to generate list view"
                        : "List view is unavailable"
                    }
                    placement={"bottom"}
                    trigger={["hover"]}
                  >
                    <Button
                      active={isList && activeTab === "EXPLORE"}
                      onClick={() => {
                        this.handleUpdateIsList(true);

                        if (activeTab !== "EXPLORE") {
                          updateActiveTab("EXPLORE");
                        }
                      }}
                      disabled={!hasOutcome || !hasHexes}
                    >
                      <div className={styles.bFlex}>
                        <Icon size={16} src={ListViewHeaderIcon} />
                      </div>
                    </Button>
                  </Tooltip>
                )}
              {!IS_SIMPLE_MODE &&
                ((isEnabled("chat-aible-consumer") && isEnabled("chat-aible-advanced-controls")) ||
                  (isEnabled("chat-aible") && (isEnabled("aible-optimize") || isEnabled("aible-explore")))) && (
                  <Tooltip overlay={"Show ChatAible"} placement={"bottom"} trigger={["hover"]}>
                    <Button
                      active={activeTab === "CHATGPT"}
                      onClick={() => {
                        updateActiveTab("CHATGPT");
                      }}
                    >
                      <div className={styles.bFlex}>
                        <Icon size={16} src={chatIcon} />
                      </div>
                    </Button>
                  </Tooltip>
                )}
              {!IS_SIMPLE_MODE && isEnabled("nlq-dashboard") && (
                <Tooltip overlay={"Show Chat Dashboard"} placement={"bottom"} trigger={["hover"]}>
                  <Button
                    active={activeTab === "NLQ Dashboard"}
                    onClick={() => {
                      updateActiveTab("NLQ Dashboard");
                    }}
                  >
                    <div className={styles.bFlex}>
                      <Icon size={16} src={NLQDashIcon} />
                    </div>
                  </Button>
                </Tooltip>
              )}
              {isEnabled("classic-view") && projectId !== undefined && (
                <Tooltip overlay={"Show Classic View"} placement={"bottom"} trigger={["hover"]}>
                  <Button onClick={() => history.push("/project/" + projectId + "/" + id)}>
                    <div className={styles.bFlex}>
                      <Icon size={16} src={ClassicIcon} />
                    </div>
                  </Button>
                </Tooltip>
              )}
            </ButtonGroup>
          )}

        {activeTab !== "EXPLORE" &&
          activeTab !== "DASHBOARD" &&
          activeTab !== "CHATGPT" &&
          activeTab !== "NLQ Dashboard" &&
          isEnabled("classic-view") &&
          projectId !== undefined && (
            <Tooltip overlay={"Show Classic View"} placement={"bottom"} trigger={["hover"]}>
              <Button onClick={() => history.push("/project/" + projectId + "/" + id)}>
                <div className={styles.bFlex}>
                  <Icon size={16} src={ClassicIcon} />
                </div>
              </Button>
            </Tooltip>
          )}

        <ButtonGroup style={{ marginLeft: "10px" }}>
          {(activeTab === "MODELS" || activeTab === "EXPLORE") && projectId !== undefined && !isShareLink && (
            <Button
              id="tasksButton"
              onClick={() => updateIsTasks(!isTasks)}
              active={isTasks}
              style={{ position: "relative" }}
            >
              {"Tasks"}
              {hasPendingTasks && <div className={styles.pendingTasks} />}
            </Button>
          )}
        </ButtonGroup>

        {activeTab === "EXPLORE" && !isShareLink && (
          <div style={{ marginLeft: "10px" }} id="pptButton">
            <Button id="pptButton" onClick={() => saveAsPpt()}>
              <img src={PPTDownloadIcon} alt="download icon" style={{ marginRight: "5px" }} />
              {"Download PPT"}
            </Button>
          </div>
        )}
        {activeTab === "MODELS" && optimized && optimized.id && !isShareLink && (
          <div style={{ marginLeft: "10px" }} id="pptButton">
            <OverlayTrigger
              placement="top"
              trigger={allScenarios && allScenarios.length === 0 ? ["hover"] : []}
              rootClose
              overlay={
                <Popover id="popover-positioned-top">
                  <div>{"Please save at least one scenario to enable powerpoint download"}</div>
                </Popover>
              }
            >
              <Button
                onClick={() => exportToPowerpointProject()}
                disabled={project.settings.powerpointExporterIsRunning || (allScenarios && allScenarios.length === 0)}
              >
                {project.settings.powerpointExporterIsRunning ? (
                  <LoadingIndicator
                    style={{
                      width: "20px",
                      height: "18px",
                      transform: "scale(0.30)",
                      margin: "-5px 5px 5px -10px"
                    }}
                  />
                ) : (
                  <div className={styles.downloadPPTButton}>
                    <img
                      src={
                        project.settings.powerpointExporterIsRunning || (allScenarios && allScenarios.length === 0)
                          ? GreyPPTDownloadIcon
                          : PPTDownloadIcon
                      }
                      alt="download icon"
                      style={{ marginRight: "5px" }}
                    />
                    <div>{`Download PPT`}</div>
                  </div>
                )}
              </Button>
            </OverlayTrigger>
          </div>
        )}
        {activeTab === "CHATGPT" &&
          !isShareLink &&
          (isEnabled("chat-aible-advanced-controls") || chatGPTShowSettings) && (
            <Button
              onClick={() => {
                chatGPTUpdateShowSettings(!chatGPTShowSettings);
              }}
              active={chatGPTShowSettings}
              type={"secondary"}
            >
              {"Chat Options"}
            </Button>
          )}
        {!isShareLink && (
          <React.Fragment>
            {/* Removing blueprint !== undefined and id === "new" check now that agents render next on open */}
            {blueprintId === "new" ? (
              <Dropdown id="saveBp" pullRight style={{ minWidth: "186px" }}>
                <Button
                  style={{
                    marginLeft: "10px",
                    color: blueprintId === "new" ? "#FFFFFF" : undefined
                  }}
                  className={styles.splitButton}
                  type={blueprintId === "new" ? "primary" : "default"}
                  onClick={() => saveBlueprint(blueprintId)}
                >
                  {"Save as New Blueprint"}
                </Button>
                <Dropdown.Toggle
                  style={{
                    padding: "8.5px 6px 8px",
                    borderTopRightRadius: "6px",
                    borderBottomRightRadius: "6px"
                  }}
                />
                {blueprint && (
                  <Dropdown.Menu>
                    <MenuItem
                      eventKey="1"
                      onClick={() => {
                        const retBlueprint = {
                          ...blueprint,
                          name: reportLabel ? reportLabel : blueprint.name,
                          wizard: blueprint?.wizard?.setup
                            ? {
                                ...blueprint.wizard,
                                setup: {
                                  ...blueprint.wizard.setup,
                                  label: reportLabel ? reportLabel : blueprint.wizard.setup.label
                                },
                                segmentSetups: segmentSetups
                              }
                            : { ...(blueprint.wizard ?? {}), segmentSetups: segmentSetups }
                        };

                        toast("Blueprint copied to clipboard.", {
                          type: toast.TYPE.SUCCESS,
                          position: toast.POSITION.TOP_CENTER,
                          autoClose: 3500
                        });
                        navigator.clipboard.writeText(JSON.stringify(retBlueprint));
                      }}
                    >
                      <div style={{ color: "#7E69D7" }}>Export Blueprint</div>
                    </MenuItem>
                  </Dropdown.Menu>
                )}
              </Dropdown>
            ) : (
              <ButtonToolbar style={{ marginLeft: "10px", flexShrink: "0" }} id="saveButton">
                {activeTab !== "CHATGPT" ? (
                  <Dropdown id="save" pullRight>
                    {isSavingReport === true ? (
                      <Button className={styles.splitButton} disabled={true}>
                        <LoadingIndicator
                          style={{
                            height: "20px",
                            margin: "0px",
                            top: "-10px",
                            transform: "scale(0.4)"
                          }}
                        />
                        {!manualSaving ? "Auto-saving" : null}
                      </Button>
                    ) : (
                      <Button
                        className={clsx(activeTab !== "DASHBOARD" && styles.splitButton)}
                        style={{ color: shouldSaveProject ? "#FFFFFF" : undefined }}
                        onClick={() => {
                          this.setState({
                            shouldSaveProject: undefined,
                            manualSaving: true
                          });
                          saveNext().then(() => {
                            this.setState({
                              manualSaving: false
                            });
                          });
                        }}
                        type={shouldSaveProject ? "primary" : "secondary"}
                        greyscaleDefaultState
                      >
                        {"Save"}
                      </Button>
                    )}
                    {activeTab !== "DASHBOARD" && (
                      <Dropdown.Toggle
                        style={{
                          padding: "8px 6px 8.5px",
                          borderTopRightRadius: "6px",
                          borderBottomRightRadius: "6px"
                        }}
                      />
                    )}
                    <Dropdown.Menu>
                      <MenuItem eventKey="1" onClick={() => saveBlueprint(blueprintId)}>
                        <div style={{ color: "#7E69D7" }}>Save Project as Blueprint</div>
                      </MenuItem>
                      {blueprint && (
                        <MenuItem
                          eventKey="2"
                          onClick={() => {
                            toast("Blueprint copied to clipboard.", {
                              type: toast.TYPE.SUCCESS,
                              position: toast.POSITION.TOP_CENTER,
                              autoClose: 3500
                            });

                            const retBlueprint = {
                              ...blueprint,
                              wizard: {
                                ...(blueprint.wizard ?? {}),
                                setup: optimized?.setup ?? blueprint?.wizard?.setup,
                                segmentSetups: segmentSetups
                              }
                            };

                            navigator.clipboard.writeText(JSON.stringify(retBlueprint));
                          }}
                        >
                          <div style={{ color: "#7E69D7" }}>Export Blueprint</div>
                        </MenuItem>
                      )}
                      <MenuItem
                        eventKey="3"
                        onClick={() => {
                          const retHideMiniMap = !this.state.hideMinimap;
                          this.setState({ hideMinimap: retHideMiniMap });
                          if (retHideMiniMap) {
                            localStorage.setItem("aible_hide_minimap", retHideMiniMap);
                          } else {
                            localStorage.removeItem("aible_hide_minimap");
                          }
                        }}
                      >
                        <div style={{ color: "#7E69D7" }}>
                          {this.state.hideMinimap === true ? "Show Map" : "Hide Map"}
                        </div>
                      </MenuItem>
                      {isEnabled("nlq-dashboard") && (
                        <MenuItem
                          eventKey="5"
                          onClick={() => {
                            const url =
                              window.location.href + (window.location.href.indexOf("/__dash") === -1 ? "/__dash" : "");

                            toast("Dashboard URL copied to clipboard.", {
                              type: toast.TYPE.SUCCESS,
                              position: toast.POSITION.TOP_CENTER,
                              autoClose: 3500
                            });

                            navigator.clipboard.writeText(url).then((c) => console.log("clipboard stuff"));
                            //window.open(url);
                          }}
                        >
                          <div style={{ color: "#7E69D7" }}>{"Share Link To Chat Dashboard"}</div>
                        </MenuItem>
                      )}
                      <MenuItem
                        eventKey="4"
                        onClick={() => {
                          if (exploreDefaultViewMode !== "EXPLORE") {
                            updateExploreDefaultViewMode("EXPLORE");
                            this.setState({ isDefaultExplore: true });
                          } else {
                            updateExploreDefaultViewMode("DASHBOARD");
                            this.setState({ isDefaultExplore: false });
                          }
                        }}
                      >
                        <div className={styles.dropdownItem}>
                          <input type={"checkbox"} checked={this.state.isDefaultExplore} style={{ margin: "0px" }} />
                          <div style={{ marginLeft: "6px" }}>{"Default Explore View to Powerful"}</div>
                        </div>
                      </MenuItem>
                      <MenuItem
                        eventKey="6"
                        onClick={() => {
                          updateChatRestrictChartsToPinned(!chatRestrictChartsToPinned);
                        }}
                      >
                        <div className={styles.dropdownItem}>
                          <input
                            type={"checkbox"}
                            checked={chatRestrictChartsToPinned}
                            style={{ margin: "0px", pointerEvents: "none" }}
                          />
                          <div style={{ marginLeft: "6px" }}>{"Restrict chat to pinned explore charts"}</div>
                        </div>
                      </MenuItem>
                    </Dropdown.Menu>
                  </Dropdown>
                ) : isSavingReport === true ? (
                  <Button disabled={true}>
                    <LoadingIndicator
                      style={{
                        height: "20px",
                        margin: "0px",
                        top: "-10px",
                        transform: "scale(0.4)"
                      }}
                    />
                    {!manualSaving ? "Auto-saving" : null}
                  </Button>
                ) : (
                  <Button
                    style={{ color: shouldSaveProject ? "#FFFFFF" : undefined }}
                    onClick={() => {
                      this.setState({
                        shouldSaveProject: undefined
                      });
                      saveNext("Chat Saved");
                    }}
                    type={shouldSaveProject ? "primary" : "secondary"}
                  >
                    {"Save"}
                  </Button>
                )}
              </ButtonToolbar>
            )}
            {isRetraining ? (
              <div className={styles.retrainButton} style={{ marginLeft: "30px" }}>
                <LoadingIndicator style={{ margin: "0px" }} />
              </div>
            ) : hasSetupIgnoreChanged ? (
              <Button
                type="primary"
                onClick={() => {
                  retrainRun(projectId);
                }}
                style={{ marginLeft: "10px" }}
              >
                {"Retrain AI"}
              </Button>
            ) : (
              ""
            )}
          </React.Fragment>
        )}
      </div>
    );
  }

  renderChatGPT() {
    const { id, optimizeSetup, optimizeSetupHasSplits } = this.props;

    return (
      <div className={styles.chatGPTHolder}>
        <ChatGPTContainer nextId={id} />
      </div>
    );
  }

  render() {
    const {
      id,
      projectId,
      dataset,
      blueprintId,
      runId,
      innerHexSize,
      hexSize,
      hexagonRadius,
      isComment,
      isTasks,
      isLeftClosed,
      selectedHex,
      selectedHexTransform,
      project,
      hasConsultantAction,
      activeTab,
      selectedHexModels,
      hasSplits,
      hexMap,
      projectIsLoading,
      isReportExpand
    } = this.props;
    const { fakeZoom, nextZoomSize, isList } = this.state;

    if (activeTab === undefined) {
      return <LoadingIndicator style={{ height: "calc(100vh - 60px)", margin: "40vh auto" }} />;
    }

    if (
      activeTab !== "DASHBOARD" &&
      activeTab !== "CHATGPT" &&
      activeTab !== "NLQ Dashboard" &&
      ((projectId !== undefined && (projectIsLoading || project === undefined || Object.keys(project)?.length === 0)) ||
        hexagonRadius === undefined ||
        (activeTab !== "FORECASTING" &&
          activeTab !== "CHATGPT" &&
          (hexMap === undefined || Object.keys(hexMap).length === 0)))
    ) {
      return <LoadingIndicator style={{ height: "calc(100vh - 60px)", margin: "40vh auto" }} />;
    }

    const retIsList = isList && activeTab === "EXPLORE";

    const rowColsCount = hexagonRadius * 2 + 1;

    const showMinimap =
      activeTab === "TRANSFORM"
        ? true
        : activeTab !== "FORECASTING" &&
          activeTab !== "DETAIL" &&
          activeTab !== "MONITOR" &&
          retIsList !== true &&
          this.state.hideMinimap !== true &&
          !this.getIsAutoHideMinimap();

    if (activeTab === "DETAIL") {
      return (
        <div className={styles.mOuter}>
          <div className={styles.edgHolder}>
            <GalleryContainer datasetId={dataset ? dataset.id : id} isNext nextId={id} runId={runId} />
          </div>
          {this.renderHeader()}
        </div>
      );
    }

    return (
      <div className={styles.nextHolderSection}>
        <div className={styles.mOuter}>
          {/* LEFT PANEL */}
          {activeTab === "FORECASTING" || activeTab === "DASHBOARD" ? (
            <React.Fragment />
          ) : activeTab === "CHATGPT" ? (
            this.renderChatGPT()
          ) : activeTab === "NLQ Dashboard" ? (
            this.renderChatGPT()
          ) : activeTab === "OVERVIEW" ? (
            this.renderOverview()
          ) : activeTab === "MODELS" ? (
            this.renderModels()
          ) : (
            <div
              className={
                activeTab === "TRANSFORM"
                  ? styles.nextReportHolder
                  : activeTab === "MONITOR"
                    ? styles.nextReportHolderMonitor
                    : styles.nextReportHolder
              }
              style={
                isReportExpand
                  ? { width: "100vw", maxWidth: "unset" }
                  : isLeftClosed
                    ? { width: "0px", overflow: "hidden" }
                    : {}
              }
              id={"leftPanel"}
            >
              {hasSplits && activeTab === "MONITOR" && (
                <SubgroupMenuContainer id={projectId} updateShow={() => {}} isNext nextId={id} />
              )}
              <NextReportContainer
                id={id}
                datasetId={dataset ? dataset.id : id}
                isTransform={activeTab === "TRANSFORM"}
                activeTab={activeTab}
                hasSplits={hasSplits}
                isList={retIsList}
              />
              {activeTab === "TRANSFORM" &&
                selectedHexModels &&
                selectedHexModels.leftSection === "SUBGROUP" &&
                this.renderLeft()}
            </div>
          )}
          <div
            className={styles.comments}
            style={isComment && activeTab === "EXPLORE" ? { width: "500px" } : { width: "0px" }}
          >
            {this.renderComments()}
          </div>
          <div
            className={styles.comments}
            style={
              isTasks && (activeTab === "MODELS" || activeTab === "EXPLORE") ? { width: "500px" } : { width: "0px" }
            }
          >
            {this.renderTasks()}
          </div>
          <div
            className={
              activeTab === "DASHBOARD"
                ? styles.nextDashboard
                : activeTab === "TRANSFORM"
                  ? styles.nextTransform
                  : activeTab === "OVERVIEW"
                    ? styles.nextOverview
                    : activeTab === "FORECASTING"
                      ? styles.nextForecasting
                      : activeTab === "DETAIL"
                        ? styles.edgHelp
                        : activeTab === "MODELS"
                          ? styles.nextModels
                          : activeTab === "EXPLORE"
                            ? styles.nextExplore
                            : styles.next
            }
            ref={this.divRef}
            id="mainScroll"
            style={
              activeTab === "MODELS"
                ? {
                    width: "66.666vw",
                    minWidth: "calc(100vw - 500px)",
                    marginLeft: "min(500px, 66.666vw)"
                  }
                : isLeftClosed === true ||
                    activeTab === "DETAIL" ||
                    activeTab === "FORECASTING" ||
                    activeTab === "DASHBOARD"
                  ? { width: "100%", marginLeft: "0px" }
                  : {}
            }
            onDragOver={(e) => {
              e.preventDefault();
            }}
          >
            {activeTab === "CHATGPT" && window?.looker_API !== undefined ? (
              <div />
            ) : activeTab === "NLQ Dashboard" ? (
              <ChatGPTHeader id={id} />
            ) : (
              this.renderHeader()
            )}
            {activeTab === "DASHBOARD" || activeTab === "CHATGPT" ? (
              <div />
            ) : activeTab === "FORECASTING" ? (
              <ForecastContainer id={runId} projectId={projectId} />
            ) : activeTab !== "DETAIL" && retIsList && activeTab !== "TRANSFORM" ? (
              this.renderList()
            ) : (
              <div />
            )}
            {activeTab === "DASHBOARD" ? (
              <DashboardHolderContainer datasetId={dataset?.id} id={id} />
            ) : activeTab === "CHATGPT" || activeTab === "NLQ Dashboard" ? (
              <React.Fragment />
            ) : (
              retIsList !== true && (
                <div>
                  <div
                    className={styles.hexOuterGrid}
                    style={
                      isReportExpand
                        ? { display: "none" }
                        : activeTab === "FORECASTING"
                          ? {
                              maxHeight: "0px",
                              maxWidth: "0px",
                              overflow: "hidden"
                            }
                          : {
                              minHeight: rowColsCount * innerHexSize + innerHexSize / 4 + "px",
                              minWidth: rowColsCount * innerHexSize + "px",
                              display: retIsList ? "none" : "block"
                            }
                    }
                  >
                    <div
                      id="hexGridInner"
                      className={styles.hexGrid}
                      style={{
                        height: rowColsCount * innerHexSize + innerHexSize / 4 + "px",
                        width: rowColsCount * innerHexSize + "px",
                        transform: "scale(" + fakeZoom / hexSize + ")"
                      }}
                    >
                      <div id="hexGridSection" className={styles.hexGridSection} style={{ left: "max(40vw, 600px)" }} />
                      {/* RIGHT HEX GRID */}
                      {activeTab === "MONITOR" ? (
                        <div />
                      ) : activeTab === "TRANSFORM" ? (
                        <div className={styles.transformRight}>
                          <TransformContainer id={id} />
                        </div>
                      ) : activeTab === "MODELS" ? (
                        <div className={styles.transformRight}>
                          <ModelsContainer id={id} blueprintId={blueprintId} />
                        </div>
                      ) : activeTab === "OVERVIEW" ? (
                        <div className={styles.transformRight}>
                          <OverviewContainer />
                        </div>
                      ) : (
                        <HexGridContainer id={id} />
                      )}
                    </div>
                  </div>
                </div>
              )
            )}
            {retIsList !== true &&
              activeTab !== "DASHBOARD" &&
              activeTab !== "CHATGPT" &&
              activeTab !== "NLQ Dashboard" && (
                <div
                  className={styles.minimap + " " + (showMinimap && isReportExpand !== true ? "" : styles.hide)}
                  style={hasConsultantAction ? { bottom: "130px" } : {}}
                >
                  <div className={styles.centerButton}>
                    <Button onClick={() => centerHex(selectedHex)} style={{ padding: "4px", transform: "scale(1.75)" }}>
                      <FontAwesomeIcon icon={faMapMarker} />
                    </Button>
                  </div>
                  <div
                    className={styles.minimapInner}
                    ref={this.miniRef}
                    id="miniScroll"
                    onMouseDown={() => this.setState({ canDrag: true })}
                    onMouseUp={() => this.setState({ canDrag: false })}
                    onMouseLeave={() => this.setState({ canDrag: false })}
                    onClick={(e) => this.handleMiniClick(e)}
                  >
                    <HexGridContainer id={id} isMini mType={activeTab} />
                    <MinimapViewContainer id={id} nextZoomSize={nextZoomSize} hexSize={hexSize} />
                  </div>
                </div>
              )}
            {activeTab !== "OVERVIEW" &&
              activeTab !== "FORECASTING" &&
              activeTab !== "MONITOR" &&
              activeTab !== "DASHBOARD" &&
              activeTab !== "CHATGPT" &&
              activeTab !== "NLQ Dashboard" &&
              this.renderFooter()}
            {this.renderGuideModal()}
            {this.props.isReviewing && this.renderReviewingJob()}
            <CommentModalContainer id={id} />
          </div>
        </div>
      </div>
    );
  }
}
